// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import Mint from 'mint-ui';
import 'mint-ui/lib/style.css'
import { Header } from 'mint-ui';
import { Field } from 'mint-ui';
import { Radio } from 'mint-ui';
import { Button } from 'mint-ui';
import { MessageBox } from 'mint-ui';
import { Popup } from 'mint-ui';
import VueResource from 'vue-resource';
import { Switch } from 'mint-ui';
import 'font-awesome/css/font-awesome.min.css'
import lodash from 'lodash'

const VueGoogleMaps = require('vue2-google-maps');

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBK1UdPeQoFK1cqoS_smoW3FoRbHOldERE',
    v: '3',
    libraries: 'places'
  }
});

Vue.component(Switch.name, Switch);

Vue.use(Mint);
Vue.use(VueResource);
Vue.component(Popup.name, Popup);

Vue.component(Header.name, Header);
Vue.component(Field.name, Field);
Vue.component(Radio.name, Radio);
Vue.component(Button.name, Button);
Vue.config.productionTip = false;
Vue.prototype.$lodash = lodash


/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js